import { render, staticRenderFns } from "./AnnouncementEdit.vue?vue&type=template&id=ca550a46&"
import script from "./AnnouncementEdit.vue?vue&type=script&lang=js&"
export * from "./AnnouncementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports